<div class="consolidado-caixa-page">
  <section class="consolidado-filtros">
    <div class="periodos-rapidos">
      <button type="button" [class.ativo]="periodoAtivo === 'hoje'" (click)="selecionePeriodo('hoje')">Hoje</button>
      <button type="button" [class.ativo]="periodoAtivo === 'semana'" (click)="selecionePeriodo('semana')">Semana atual</button>
      <button type="button" [class.ativo]="periodoAtivo === 'mes'" (click)="selecionePeriodo('mes')">Mês atual</button>
      <button type="button" [class.ativo]="periodoAtivo === 'personalizado'" (click)="selecionePeriodo('personalizado')">Personalizado</button>
    </div>

    <div class="filtros-grid">
      <div class="filtro-campo">
        <label>Período de abertura</label>
        <div class="periodo-datas">
          <kendo-datepicker [(ngModel)]="dataInicial" (valueChange)="marquePeriodoPersonalizado()"
                            format="dd/MM/yyyy" placeholder="De"></kendo-datepicker>
          <kendo-datepicker [(ngModel)]="dataFinal" (valueChange)="marquePeriodoPersonalizado()"
                            format="dd/MM/yyyy" placeholder="Até"></kendo-datepicker>
        </div>
      </div>

      <div class="filtro-campo">
        <label>Operadores</label>
        <kendo-multiselect
          [data]="operadoresDisponiveis"
          textField="nome"
          valueField="chave"
          [valuePrimitive]="true"
          [(ngModel)]="operadoresSelecionados"
          [autoClose]="false"
          placeholder="Todos os operadores">
        </kendo-multiselect>
      </div>

      <div class="filtro-campo">
        <label>Formas de pagamento</label>
        <kendo-multiselect
          [data]="formasDisponiveis"
          textField="descricao"
          valueField="id"
          [valuePrimitive]="true"
          [(ngModel)]="formasSelecionadas"
          [autoClose]="false"
          placeholder="Todas as formas">
        </kendo-multiselect>
      </div>

      <div class="filtro-acoes">
        <button type="button" class="btn-secundario" (click)="limpeFiltros()" [disabled]="carregando">
          <i class="fas fa-filter"></i> Limpar
        </button>
        <button type="button" class="btn-primario" (click)="apliqueFiltros()" [disabled]="carregando">
          <i class="fas fa-search"></i> Aplicar
        </button>
      </div>
    </div>

    <div class="criterio-periodo">
      <i class="fas fa-info-circle"></i>
      O período considera a data de abertura. Todas as movimentações dos caixas abertos no intervalo serão consolidadas.
    </div>
  </section>

  <div class="alerta-erro" *ngIf="erro">{{erro}}</div>

  <section class="cards-totais" [class.carregando]="carregando">
    <div class="card-total">
      <span>Total de abertura dos caixas</span>
      <strong>{{consolidado.totais.saldoInicial | currency:'BRL'}}</strong>
    </div>
    <div class="card-total entrada">
      <span>Entradas</span>
      <strong>{{consolidado.totais.entradas | currency:'BRL'}}</strong>
    </div>
    <div class="card-total saida">
      <span>Estornos / Saídas</span>
      <strong>{{consolidado.totais.estornos | currency:'BRL'}}</strong>
    </div>
    <div class="card-total saida">
      <span>Sangrias</span>
      <strong>{{consolidado.totais.sangrias | currency:'BRL'}}</strong>
    </div>
    <div class="card-total fiado" *ngIf="moduloFiadoAtivo">
      <span>Fiado líquido</span>
      <strong>{{consolidado.totais.fiado | currency:'BRL'}}</strong>
    </div>
    <div class="card-total resultado" [class.negativo]="consolidado.totais.resultado < 0">
      <span>Resultado líquido</span>
      <strong>{{consolidado.totais.resultado | currency:'BRL'}}</strong>
    </div>
  </section>

  <div class="consolidado-toolbar">
    <span>{{consolidado.totais.quantidadeMovimentacoes || 0}} movimentação(ões)</span>
    <button type="button" class="btn-exportar" (click)="exporteExcel()" [disabled]="carregando || exportando">
      <i class="fas fa-file-excel"></i>
      {{exportando ? 'Exportando...' : 'Exportar Excel'}}
    </button>
  </div>

  <section class="tabela-consolidado">
    <h5>Por operador</h5>
    <kendo-grid [data]="consolidado.porOperador" [loading]="carregando" [scrollable]="'none'">
      <kendo-grid-messages noRecords="Nenhuma movimentação por operador encontrada." loading="Carregando"></kendo-grid-messages>
      <kendo-grid-column field="nome" title="Operador" [width]="180">
        <ng-template kendoGridFooterTemplate><strong>TOTAL</strong></ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="quantidadeMovimentacoes" title="Mov." [width]="75">
        <ng-template kendoGridFooterTemplate><strong>{{consolidado.totais.quantidadeMovimentacoes || 0}}</strong></ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="entradas" title="Entradas" [width]="120">
        <ng-template kendoGridCellTemplate let-item>{{item.entradas | currency:'BRL'}}</ng-template>
        <ng-template kendoGridFooterTemplate><strong>{{consolidado.totais.entradas | currency:'BRL'}}</strong></ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="estornos" title="Estornos/Saídas" [width]="135">
        <ng-template kendoGridCellTemplate let-item>{{item.estornos | currency:'BRL'}}</ng-template>
        <ng-template kendoGridFooterTemplate><strong>{{consolidado.totais.estornos | currency:'BRL'}}</strong></ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="sangrias" title="Sangrias" [width]="115">
        <ng-template kendoGridCellTemplate let-item>{{item.sangrias | currency:'BRL'}}</ng-template>
        <ng-template kendoGridFooterTemplate><strong>{{consolidado.totais.sangrias | currency:'BRL'}}</strong></ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="fiado" title="Fiado" [width]="110" *ngIf="moduloFiadoAtivo">
        <ng-template kendoGridCellTemplate let-item>{{item.fiado | currency:'BRL'}}</ng-template>
        <ng-template kendoGridFooterTemplate><strong>{{consolidado.totais.fiado | currency:'BRL'}}</strong></ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="resultado" title="Resultado" [width]="120">
        <ng-template kendoGridCellTemplate let-item>
          <strong [class.valor-negativo]="item.resultado < 0">{{item.resultado | currency:'BRL'}}</strong>
        </ng-template>
        <ng-template kendoGridFooterTemplate>
          <strong [class.valor-negativo]="consolidado.totais.resultado < 0">{{consolidado.totais.resultado | currency:'BRL'}}</strong>
        </ng-template>
      </kendo-grid-column>
    </kendo-grid>
  </section>

  <section class="tabela-consolidado">
    <h5>Por forma de pagamento</h5>
    <kendo-grid [data]="consolidado.porFormaPagamento" [loading]="carregando" [scrollable]="'none'">
      <kendo-grid-messages noRecords="Nenhuma movimentação por forma de pagamento encontrada." loading="Carregando"></kendo-grid-messages>
      <kendo-grid-column field="descricao" title="Forma de pagamento" [width]="180">
        <ng-template kendoGridFooterTemplate><strong>TOTAL</strong></ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="quantidadeMovimentacoes" title="Mov." [width]="75">
        <ng-template kendoGridFooterTemplate><strong>{{consolidado.totais.quantidadeMovimentacoes || 0}}</strong></ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="entradas" title="Entradas" [width]="120">
        <ng-template kendoGridCellTemplate let-item>{{item.entradas | currency:'BRL'}}</ng-template>
        <ng-template kendoGridFooterTemplate><strong>{{consolidado.totais.entradas | currency:'BRL'}}</strong></ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="estornos" title="Estornos/Saídas" [width]="135">
        <ng-template kendoGridCellTemplate let-item>{{item.estornos | currency:'BRL'}}</ng-template>
        <ng-template kendoGridFooterTemplate><strong>{{consolidado.totais.estornos | currency:'BRL'}}</strong></ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="sangrias" title="Sangrias" [width]="115">
        <ng-template kendoGridCellTemplate let-item>{{item.sangrias | currency:'BRL'}}</ng-template>
        <ng-template kendoGridFooterTemplate><strong>{{consolidado.totais.sangrias | currency:'BRL'}}</strong></ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="fiado" title="Fiado" [width]="110" *ngIf="moduloFiadoAtivo">
        <ng-template kendoGridCellTemplate let-item>{{item.fiado | currency:'BRL'}}</ng-template>
        <ng-template kendoGridFooterTemplate><strong>{{consolidado.totais.fiado | currency:'BRL'}}</strong></ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="resultado" title="Resultado" [width]="120">
        <ng-template kendoGridCellTemplate let-item>
          <strong [class.valor-negativo]="item.resultado < 0">{{item.resultado | currency:'BRL'}}</strong>
        </ng-template>
        <ng-template kendoGridFooterTemplate>
          <strong [class.valor-negativo]="consolidado.totais.resultado < 0">{{consolidado.totais.resultado | currency:'BRL'}}</strong>
        </ng-template>
      </kendo-grid-column>
    </kendo-grid>
  </section>
</div>
